export class DataCollector {
  /**
     *
     * @param {{[key: string]: {collector: Function, times?:number, time?: number}}} configs
     * @param {(name: string, data)=>void} onNewData
     */
  constructor(configs, onNewData) {
    this.configs = configs;
    this.onNewData = onNewData;
    this.collectors = {};
    this.snapshots = {};
  }

  /**
     * Start data collection
     */
  start() {
    if (this._started) return;
    this._started = true;

    for (const name in this.configs) {
      const { collector, time } = this.configs[name];
      this.collectors[name] = collector(() => this._onData(name));

      if (time) {
        setTimeout(() => this.stop(name), time);
      }
    }
  }

  /**
     * Stop all collectors
     */
  stopAll() {
    if (!this._started) return;

    for (const name in this.collectors) {
      if (this.collectors[name].stop) {
        this.collectors[name].stop();
      }
    }

    this.collectors = {};
    this.snapshots = {};

    this._started = false;
  }

  stop(name) {
    if (this.collectors[name] && this.collectors[name].stop) {
      this.collectors[name].stop();
    }
    delete this.collectors[name];
    delete this.snapshots[name];
  }

  _onData(name) {
    const collector = this.collectors[name];
    const snapshot = collector.toString();

    if (this.snapshots[name] !== snapshot) {
      this.snapshots[name] = snapshot;
      this.onNewData(name, snapshot);
    }

    const config = this.configs[name];
    if (config.times != null) {
      config.times--;

      if (config.times === 0) {
        collector.stop();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/data-collector/data-collector.js